import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  initialize() {
    const form = this.element.closest("form")
    form.addEventListener("change", () => {
      form.submit()
    })
  }
}
